import { render, staticRenderFns } from "./activityroom.vue?vue&type=template&id=c75ba856&scoped=true&"
import script from "./activityroom.vue?vue&type=script&lang=js&"
export * from "./activityroom.vue?vue&type=script&lang=js&"
import style0 from "./activityroom.vue?vue&type=style&index=0&id=c75ba856&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c75ba856",
  null
  
)

export default component.exports